import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { balanceValueClass } from '../../../utils/api-error.utils';
import { BalanceFootnotePart } from '../time-off-management/time-off-management.component';

export interface TimeOffBalanceInfoDialogData {
  /** Modal title — the balance type label, e.g. "Vacation Days". */
  title: string;
  /** Explanation split into sentences (each a list of styled parts), one line each. */
  sentences: BalanceFootnotePart[][];
}

@Component({
  selector: 'app-time-off-balance-info-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule],
  templateUrl: './time-off-balance-info-dialog.component.html',
  styleUrls: ['./time-off-balance-info-dialog.component.scss'],
})
export class TimeOffBalanceInfoDialogComponent {
  dialogRef =
    inject<MatDialogRef<TimeOffBalanceInfoDialogComponent>>(MatDialogRef);
  data = inject<TimeOffBalanceInfoDialogData>(MAT_DIALOG_DATA);

  close(): void {
    this.dialogRef.close();
  }

  /**
   * Color for the numeric values: green while positive, red once negative,
   * neutral at zero. Shared with the balance table so the modal matches the card.
   */
  getBalanceValueClass = balanceValueClass;
}
